import { render, staticRenderFns } from "./OfficialAc.vue?vue&type=template&id=7b7fea61&scoped=true&"
import script from "./OfficialAc.vue?vue&type=script&lang=js&"
export * from "./OfficialAc.vue?vue&type=script&lang=js&"
import style0 from "./OfficialAc.vue?vue&type=style&index=0&id=7b7fea61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7fea61",
  null
  
)

export default component.exports